// One-shot handoff between the door intake and the slide it just created.
//
// Submitting the intake should start the build immediately — the designer
// answered everything already; a "now click Build" stub screen is a dead step.
// But the intake modal (CourseBuilder) and the slide component (deep under
// SlideCanvas) have no prop path between them, and persisting an "auto build"
// flag into the lesson JSONB would leak a transient UI signal into saved
// content. So: a module-level one-shot registry. The intake marks the new
// slide id; the slide consumes it on mount and starts building.
//
// Deliberately in-memory only — after a refresh the slide lands on the
// briefed stub with its Build button, which is the right behaviour.

const pending = new Set<string>();

export function markPendingBuild(slideId: string): void {
  pending.add(slideId);
}

/** True exactly once per mark — consuming removes the entry. */
export function consumePendingBuild(slideId: string): boolean {
  return pending.delete(slideId);
}
